import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockAlternative32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconClockAlternative32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M26 16c0 5.523-4.477 10-10 10S6 21.523 6 16 10.477 6 16 6s10 4.477 10 10m2 0c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12m-11 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 1 1-5.713-1.282l-1.898-1.886a1 1 0 0 1 1.41-1.418l1.896 1.884a3 3 0 0 1 2.54-.033l3.13-2.985a1 1 0 1 1 1.38 1.447L18.68 14.65c.205.405.32.864.32 1.349"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockAlternative32);
